import React, { memo } from "react";
import { isSameDay } from "date-fns";
import { TruckWithShifts } from "../model/types";
import { VehicleFilters } from "./vehicle-filters";
import { VehicleCard } from "./vehicle-card";
import { useT, Namespace } from "@racoon/i18n";

interface VehicleListProps {
  vehicles: TruckWithShifts[];
  searchQuery: string;
  onSearchChange: (query: string) => void;
  startDate: Date;
  endDate: Date;
  setDateRange: (start: string, end: string) => void;
  selectedVehicleId?: string;
  onVehicleSelect: (vehicleId: string) => void;
  selectedShiftId?: string;
  onShiftSelect?: (vehicleId: string, shiftId: string) => void;
}

const VehicleListComponent: React.FC<VehicleListProps> = ({
  vehicles,
  searchQuery,
  onSearchChange,
  startDate,
  endDate,
  setDateRange,
  selectedVehicleId,
  onVehicleSelect,
  selectedShiftId,
  onShiftSelect,
}) => {
  const t = useT();
  return (
    <div className="flex flex-col h-full bg-white border rounded-xl">
      {/* Filters Section */}
      <VehicleFilters
        searchQuery={searchQuery}
        onSearchChange={onSearchChange}
        startDate={startDate}
        endDate={endDate}
        setDateRange={setDateRange}
      />

      {/* Vehicle List */}
      <div className="p-2 overflow-y-scroll">
        {vehicles.length === 0 ? (
          <div className="flex items-center justify-center h-full text-gray-500">
            {t(Namespace.GpsTracking, "noVehiclesOnDate")}
          </div>
        ) : (
          vehicles.map((vehicle) => (
            <VehicleCard
              key={String(vehicle.id)}
              vehicle={vehicle}
              isSelected={selectedVehicleId === String(vehicle.id)}
              onSelect={onVehicleSelect}
              showDates={!isSameDay(startDate, endDate)}
              selectedShiftId={selectedShiftId}
              onShiftSelect={onShiftSelect}
            />
          ))
        )}
      </div>
    </div>
  );
};

export const VehicleList = memo(VehicleListComponent);
